import React from "react";
import P from "prop-types";
import styled from "@emotion/styled";
import { css } from "@emotion/core";

const BusinessType = ({ businessType }) => {
  return (
    <>
      {businessType.map((type) => {
        if (type === "0") return <Workshop>Workshop</Workshop>;
        if (type === "1") return <Distributor >Distributor</Distributor>;
        if (type === "2") return <Shop >Shop</Shop>;
        return
      })}
    </>
  );
};

BusinessType.propTypes = {
    businessType: P.arrayOf(P.string).isRequired,
};

BusinessType.defaultProps = {
    businessType: null,
};

export default BusinessType;

const global = css`
  display: inline-block;
  padding: 3px 5px;
  font-size: 84%;
  color: #fff;
  border-radius: 3px;
  margin-left: 4px;
`;

const Workshop = styled.span`
  ${global}
  background-color: #1d1b3cb3;
`;

const Distributor = styled.span`
  ${global}
  background-color: #5d78ff;
`;

const Shop = styled.span`
  ${global}
  background-color: cadetblue;
`;